import clsx from 'clsx';
import styles from '../Select.module.css';

export function getSelectValueClassName({ variant, isEmpty }) {
  return clsx(
    styles.value,
    variant === 'form' && styles.valueForm,
    isEmpty && styles.valuePlaceholder,
  );
}

export function getSelectTriggerClassName({ variant, isEmpty, forceSurfaceBg, open, invalid }) {
  return clsx(
    styles.trigger,
    variant === 'form' && styles.triggerForm,
    variant === 'form' && isEmpty && styles.triggerFormEmpty,
    forceSurfaceBg && styles.triggerFormFilledSurface,
    open && styles.triggerOpen,
    invalid && styles.triggerInvalid,
  );
}

export function getSelectChevronClassName({ variant, open }) {
  return clsx(styles.chevron, open && styles.chevronOpen, variant === 'form' && styles.chevronForm);
}

export function getSelectMenuClassName({ menuPlacement, menuWidth }) {
  return clsx(
    styles.menu,
    menuPlacement === 'top' && styles.menuTop,
    menuWidth === 'field' && styles.menuFieldWidth,
  );
}

export function getSelectOptionClassName({ isSelected, isHighlighted }) {
  return clsx(
    styles.option,
    isSelected && styles.optionSelected,
    isHighlighted && styles.optionHighlighted,
  );
}
